import { SUPPORTED_LOCALES } from '../i18n/config';
import { isKeisukePublicEnabled } from './config';

const KEISUKE_BASE = '/keisuke';

/** 公開時の計助 URL（ja は `/keisuke`、他言語は `/en/keisuke` 等） */
export function keisukePublicPath(locale: string): string {
  if (!isKeisukePublicEnabled()) return KEISUKE_BASE;
  if (locale === 'ja' || locale.startsWith('ja-')) return KEISUKE_BASE;
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) return `/${locale}${KEISUKE_BASE}`;
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) return `/${short}${KEISUKE_BASE}`;
  return KEISUKE_BASE;
}

export function isKeisukePublicPathname(pathname: string): boolean {
  if (!isKeisukePublicEnabled()) return false;
  return isKeisukeWorkspacePathname(pathname);
}

/** Layout のフルビューポート判定（公開フラグに依存しない） */
export function isKeisukeWorkspacePathname(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === KEISUKE_BASE || path.startsWith(`${KEISUKE_BASE}/`)) return true;
  return SUPPORTED_LOCALES.some(
    (loc) =>
      loc !== 'ja' &&
      (path === `/${loc}${KEISUKE_BASE}` || path.startsWith(`/${loc}${KEISUKE_BASE}/`))
  );
}
